import { render } from "./TalentProfile.vue?vue&type=template&id=2926c28c"
import script from "./TalentProfile.vue?vue&type=script&lang=js"
export * from "./TalentProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__